import { render, staticRenderFns } from "./UpdateRepairCard.vue?vue&type=template&id=22a78d02&scoped=true"
import script from "./UpdateRepairCard.vue?vue&type=script&lang=js"
export * from "./UpdateRepairCard.vue?vue&type=script&lang=js"
import style0 from "./UpdateRepairCard.vue?vue&type=style&index=0&id=22a78d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a78d02",
  null
  
)

export default component.exports